import { render, staticRenderFns } from "./PaymentForSaleDownPayment.vue?vue&type=template&id=a287f4ca"
import script from "./PaymentForSaleDownPayment.vue?vue&type=script&lang=js"
export * from "./PaymentForSaleDownPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports